// for search employee and customer

export const RESET_SEARCH_EMPLOYEE_AND_CUSTOMER = "reset_search_employee_and_customer";
export const SEARCH_EMPLOYEE_AND_CUSTOMER = "search_employee_and_customer";
export const SEARCH_EMPLOYEE_AND_CUSTOMER_SUCCESS = "search_employee_and_customer_success";
export const SEARCH_EMPLOYEE_AND_CUSTOMER_FAILURE = "search_employee_and_customer_failure";
